<template>
  <div>
    <v-row>
      <v-col cols="11">
        <Breadcrumb class="row justify-content-center mt-4" />
      </v-col>
      <v-col cols="1" v-if="showLoader">
        <LoaderProgress></LoaderProgress>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="5"
      :mobile-breakpoint="0"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="openWidgetDialog(item)">
          icon-action
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogwidgetShow" max-width="600px">
      <v-card>
        <v-card-title class="background-blue">
          <span class="text-h5 icon-white">Edit Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Username "
                  :items="customersUser"
                  v-model="changedUser"
                  item-text="user_name"
                  item-value="user_id"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn rounded color="#FE000C" @click="close">
            <v-icon left class="icon-white" style="color: white;"
              >icon-cancel</v-icon
            >
            <span
              style="color:white; font-family: roboto, sans-serif; font-weight:700"
            >
              Cancel</span
            >
          </v-btn>
          <v-btn rounded color="primary" @click="changeApprovar()">
            <v-icon left>icon-availability</v-icon>
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import LoaderProgress from "../components/progressLoader";
import Breadcrumb from "../components/breadcrumbs.vue";
export default {
  components: {
    LoaderProgress,
    Breadcrumb,
  },
  data() {
    return {
      customer_id: "",
      disable: false,
      search: "",
      allUsers: {},
      changedUser: "",
      customersUser: [],
      selectedWidget: "",
      dialogwidgetShow: false,
      showLoader: false,
      headersData: [
        {
          text: "customer_name",
          value: "customer_name",
        },
        {
          text: "user_name",
          value: "user_name",
        },
        {
          text: "Admin Type",
          value: "access_type",
        },
        {
          text: "Action",
          value: "actions",
        },
      ],
      operatorsData: [],
    };
  },
  mounted() {
    this.getAdminApprovarsData();
    this.get_users();
  },
  methods: {
    close() {
      this.dialogwidgetShow = false;
    },
    changeApprovar(item) {
      this.disable = true;
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateAdminApprovar`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          AdminCustomer_id: this.customer_id,
          user_id: this.changedUser,
        },
      };
      console.log("update", item, config);
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        try {
          this.changedUser = null;
          this.dialogwidgetShow = false;
          if (response.data.status) {
            console.log("status true");
            this.disable = false;
          } else {
            console.log("status false");
            this.disable = false;
          }
          console.log("data-->>", response.data.data);
          this.getAdminApprovarsData();
          this.showLoader = false;
        } catch (error) {
          this.changedUser = null;
          this.showLoader = false;
          console.log(error);
        }
      });
    },
    get_users() {
      console.log("calling getusers");
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getallusers`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        try {
          console.log("bladhjasch", response.data);
          this.allUsers = response.data;
        } catch (error) {
          this.showLoader = false;
          console.log(error);
        }
      });
    },
    getAdminApprovarsData() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getAdminApprovarsData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        try {
          console.log(response.data);
          this.operatorsData = response.data.data;
          this.showLoader = false;
        } catch (error) {
          this.showLoader = false;
          console.log(error);
        }
      });
    },
    openWidgetDialog(item) {
      this.dialogwidgetShow = true;
      this.customer_id = item.customer_id;
      this.customersUser = this.allUsers[item.customer_id];
    },
  },
};
</script>
